<!-- Create Devops Action Parameter Dialog Title-->
<h2>Create New Devops Action Parameter</h2>
<form #createNewParameterForm="ngForm" novalidate>
    <mat-dialog-content>
    </mat-dialog-content>
    <!-- Dialog Content -->
    <!-- Name -->
    <div>
        <mat-form-field class="form-field">
            <mat-label>Parameter Name</mat-label>
            <input aria-required="true" required matInput [(ngModel)]="devOpsActionParameter.name"
                name="parameterName" />
        </mat-form-field>
    </div>
    <!-- Parameter Data Type -->
    <div>
        <mat-form-field class="form-field-time">
            <mat-label>Parameter Data Type</mat-label>
            <mat-select aria-required="true" required [(ngModel)]="selectedParameterDataType" name="parameterDataType"
                (selectionChange)="onParameterDataTypeChanged()">
                <mat-option value='String'>
                    <span>String</span>
                </mat-option>
                <mat-option value='Boolean'>
                    <span>Boolean</span>
                </mat-option>
                <mat-option value='Number'>
                    <span>Number</span>
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <mat-dialog-actions>
        <!-- Dialog action buttons -->
        <button class="dialog-button" mat-raised-button color="primary" (click)="add()"
            [disabled]="createNewParameterForm.form.invalid">
            <span>Add</span>
        </button>
        <button class="dialog-button" mat-raised-button (click)="close()">Cancel</button>
    </mat-dialog-actions>
</form>